import {EditService} from "../../../../framework/entity/edit/edit-page/edit.service";
import {Component} from "@angular/core";
import {MembershipTypeEntityModel} from "../../membership-type-entity.model";

@Component({
    selector: "wbo-membership-type-edit-details",
    templateUrl: "./membership-type-edit-details.component.html"
})
export class MembershipTypeEditDetailsComponent {
    constructor(public model: MembershipTypeEntityModel, public editService: EditService) {
    }

}
